import { Link } from '@/i18n/navigation';
import { ChevronDown } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';

type Props = {
    isActive?: boolean;
};

export default function BuyerSellerDropDown({ isActive }: Props) {
    const t = useTranslations('Navigation');

    const [currentMenuOpen, setCurrentMenuOpen] = useState<boolean>(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const listItemClassName: string = `flex rounded-[8px] p-[10px] my-2 relative text-base
                                        hover:bg-[rgba(255,255,255,0.30)] cursor-pointer
                                        after:content-[''] after:absolute
                                        after:-bottom-1 after:left-0
                                        after:w-full after:h-[1px]
                                        after:bg-[rgba(255,255,255,0.10)]`;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                (event.target instanceof Element && event.target.matches('a')) ||
                (containerRef.current && event.target instanceof Node && !containerRef.current.contains(event.target))
            ) {
                setCurrentMenuOpen(false);
            }
        };

        if (currentMenuOpen) document.addEventListener('click', handleClickOutside);

        return () => document.removeEventListener('click', handleClickOutside);
    }, [currentMenuOpen]);

    return (
        <div ref={containerRef} className="relative">
            <button
                type="button"
                className={`
                        px-3 py-3 rounded-[8px] cursor-pointer flex
                        transition-colors text-white hover:text-gray-400 duration-300
                        ${isActive ? 'sm:bg-[rgba(255,255,255,0.30)]' : 'bg-[transparent]'}
                    `}
                onClick={() => setCurrentMenuOpen(!currentMenuOpen)}
            >
                <span className="pr-[10px]">{t('buyerOrSeller')}</span>
                <ChevronDown />
            </button>
            <ul
                className={`
                    px-[10px] pt-1 pb-[0.5px] absolute bg-[rgba(14,14,14,1)] rounded-[8px] z-1
                    w-[calc(100vw-32px)] sm:w-[205px]
                    md:w-auto
                    md:max-w-[300px]
                    lg:max-w-[400px]
                    max-h-[440px] sm:max-h-[initial]
                    overflow-y-auto
                    ${currentMenuOpen ? 'block' : 'hidden'}
                `}
            >
                <li>
                    <Link className={listItemClassName} href="/tv-rights-buyers">
                        {t('tvRightsBuyers')}
                    </Link>
                </li>
                <li>
                    <Link className={`${listItemClassName} after:content-[none]`} href="/tv-rights-sellers">
                        {t('tvRightsSellers')}
                    </Link>
                </li>
            </ul>
        </div>
    );
}
